import { v4 as uuidv4 } from "uuid";

/**
 * BUG-2078: builds the upsertGiftCardTransaction reversal payload for every
 * currently-active gift-card entry, giving each line its own referenceNo
 * (derived from the entry's own redemption/refId, not the shared
 * cart.referenceId). upsertGiftCardTransaction is an upsert keyed by
 * referenceNo on the backend — reusing cart.referenceId across repeated
 * removals in the same order made the second removal's call overwrite the
 * first removal's transaction row instead of creating its own.
 *
 * Returns null when there is nothing active to reverse.
 */
export const buildGiftCardReversalPayload = (giftCardData, tillId, customerId) => {
  const activeEntries = (giftCardData || []).filter((ele) => ele && ele.amount);
  if (activeEntries.length === 0) return null;

  const upsertDetails = activeEntries.map((ele) => ({
    cardNo: ele.number || null,
    type: "RD",
    referenceNo: ele.redemptionId || ele.refId || uuidv4().replace(/-/g, "").toUpperCase(),
    amount: ele.amount * -1,
    cardPin: ele.pin || null,
  }));

  const upsertDetailsStrings = upsertDetails.map(
    (detail) => `{
      cardNo: ${detail.cardNo ? `"${detail.cardNo}"` : null},
      type: "${detail.type}",
      referenceNo: "${detail.referenceNo}",
      amount: ${detail.amount},
      cardPin: ${detail.cardPin ? `"${detail.cardPin}"` : null}
      tillId: ${tillId ? `"${tillId}"` : null}
      b2c_Customer_Id: ${customerId ? `"${customerId}"` : null}
    }`
  );

  return {
    query: `
      mutation {
        upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) {
          status
          message
        }
      }`,
  };
};
